var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_WaterDepartmentPortal"}},[_c('page-head',{attrs:{"visited":_vm.visited},on:{"getVisited":_vm.getVisited}}),_c('router-view',{on:{"getVisited":_vm.getVisited}}),_c('page-foot',{attrs:{"content":_vm.companyInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }